import { render, staticRenderFns } from "./Landslide.vue?vue&type=template&id=72bc5834"
import script from "./Landslide.vue?vue&type=script&lang=js"
export * from "./Landslide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports